module.exports = __webpack_public_path__ + "static/media/Tajikistan.df6c16aa.png";